// extracted by mini-css-extract-plugin
module.exports = {"listItem":"ShipmentListPage_listItem__2otmX","shipmentStatusIcon":"ShipmentListPage_shipmentStatusIcon__1DjzV","shipmentStatusText":"ShipmentListPage_shipmentStatusText__uiFCQ"};